import { SearchQuery } from 'packages/omnitag/state';
import styled from 'styled-components';
import { SearchUI } from 'packages/omnitag/text-search/search-ui';
import { OmnitagFilter } from 'packages/lib/api/omnitag/contract/omnitag-filters';

// Aug-11-2025 - Used Gemini 2.5 Agent to make filters dynamic (searchQueryToQueryParams)
// Aug-20-2025 - Used Gemini 2.5 Agent to add support for 'number' filters
// Oct-30-2025 - Used Gemini 2.5 Agent to add support for 'DateRange' filters

const PanelLayout = styled.div`
  display: grid;
  grid-template-columns: 400px 270px;
  width: 100%;
`;

export const HorizLayout = styled.div`
  display: flex;
  align-items: center;
`;

export const searchQueryToQueryParams = (
  pageNo: number,
  pageSize: number,
  filters: OmnitagFilter[],
  query: SearchQuery
): URLSearchParams => {
  const qp = new URLSearchParams();

  qp.append('pageNo', pageNo.toString());
  qp.append('pageSize', pageSize.toString());

  if (query.logNames) {
    for (const v of query.logNames) {
      qp.append('logNames', v);
    }
  }

  for (const filter of filters) {
    if (filter.filterType === 'dateRange') {
      const from = query[`${filter.paramName}From`];
      const to = query[`${filter.paramName}To`];
      if (from) {
        qp.append(`${filter.paramName}From`, from);
      }
      if (to) {
        qp.append(`${filter.paramName}To`, to);
      }
    } else {
      const value = query[filter.paramName];
      const valueStr = value as string;
      if (value !== null && value !== undefined) {
        if (filter.filterType === 'select' && Array.isArray(value)) {
          for (const v of value as string[]) {
            qp.append(filter.paramName, v);
          }
        } else if (
          filter.filterType === 'text' &&
          typeof value === 'string' &&
          valueStr.length > 0
        ) {
          for (const v of valueStr.split(',')) {
            qp.append(filter.paramName, v);
          }
        } else if (
          filter.filterType === 'number' &&
          typeof value === 'number'
        ) {
          qp.append(filter.paramName, (value as number).toString());
        } else if (
          filter.filterType === 'toggle' &&
          typeof value === 'boolean'
        ) {
          qp.append(filter.paramName, (value as boolean).toString());
        }
      }
    }
  }

  return qp;
};

export const SearchTopPanel = (): JSX.Element => {
  return (
    <PanelLayout>
      <HorizLayout>
        <SearchUI />
        <HorizLayout
          style={{
            minWidth: '180px',
            marginLeft: '2em',
          }}
        ></HorizLayout>
      </HorizLayout>
    </PanelLayout>
  );
};
